import React from 'react';

import { createClassName } from 'utils/createClassName';

import './fieldsetLayoutStyles.css';

export const FieldsetLayoutComponent: React.FC = (props) => {
  const { children } = props;

  const createFieldsetLayoutClassName = createClassName('fieldsetLayout');

  const wrapperClassName = createFieldsetLayoutClassName('wrapper');

  return <div className={wrapperClassName}>{children}</div>;
};
